import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PconsComponent} from './pcons.component';
import {LayoutModule} from '../../components/layout/layout.module';
import {PconsSearchComponent} from './pcons-search/pcons-search.component';
import {SearchModule} from '../../components/search/search.module';
import {DialogModule} from '../../components/dialog/dialog.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule} from '@angular/forms';
import {FlexModule} from '@angular/flex-layout';
import {PipsModule} from '../../pipes/pips.module';
import {MaterialModule} from '../../material.module';
import {PconsSummaryComponent} from './pcons-summary/pcons-summary.component';
import {PconsDialogComponent} from './pcons-dialog/pcons-dialog.component';
import {DividerModule} from '../../components/separator/divider.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {VirtualPconsDialogComponent} from './virtual-pcons-dialog/virtual-pcons-dialog.component';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import { PeerConnectionStatusPipe } from './peer-connection-status.pipe';
import { PconsAdminStatePipe } from './pcons-admin-state.pipe';
import {InfraModule} from 'ac-infra';
import { PconsDetachDialogComponent } from './pcons-detach-dialog/pcons-detach-dialog.component';


@NgModule({
    declarations: [
        PconsComponent,
        PconsSearchComponent,
        PconsSummaryComponent,
        PconsDialogComponent,
        VirtualPconsDialogComponent,
        PeerConnectionStatusPipe,
        PconsAdminStatePipe,
        PconsDetachDialogComponent],
    imports: [
        CommonModule,
        LayoutModule,
        SearchModule,
        DialogModule,
        MatFormFieldModule,
        MatSelectModule,
        FormsModule,
        FlexModule,
        PipsModule,
        MaterialModule,
        DividerModule,
        ActionBarModule,
        ArmTableModule,
        InfraModule
    ]
})
export class PconsModule {
}
